<template>
  <div class="grid grid-rows-[auto,1fr] h-full">
    <ThreadsNav :show-back="true" :show-center="false" />
    <div class="overflow-auto">
      <PlanetOverview
        v-if="worldview"
        mode="explore"
        :worldview-list="[worldview]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useWorldview } from "@/stores/worldview";
import { Worldview } from "@/types/entity";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const worldview = ref<Worldview>();
const worldviewStore = useWorldview();
onMounted(async () => {
  const uuid = route.params.uuid as string;
  worldview.value = await worldviewStore.getWorldviewByUuid(uuid);
});
</script>
